export default __webpack_public_path__ + "static/media/Matrix - 47802.12e41c1e.mp4";